import { CombinedError } from "@urql/core";
import { apm } from "@elastic/apm-rum";
import * as Sentry from "@sentry/react";

export function captureGraphqlError(
  error: CombinedError,
  queryName: string,
  additionalDetails: string = "",
) {
  if (error?.response?.status !== 401) {
    const graphQLErrorsForAPM = error?.graphQLErrors?.length
      ? `| { GraphQLErrors: ${error?.graphQLErrors?.join("; ")} }`
      : "";
    const networkErrorMsg = error?.networkError?.message
      ? `| { NetworkError: ${error?.networkError?.message} }`
      : "";
    const responseMsg = error?.response ? `| { Response Status: ${error?.response?.status}}` : "";
    const errorDetails = `Error fetching ${queryName} ${graphQLErrorsForAPM} ${networkErrorMsg} ${responseMsg}${additionalDetails ? " | " : ""} ${additionalDetails}`;

    captureError(new Error(errorDetails));
  }
}

export function captureError(message: string | Error) {
  apm.captureError(message);
  Sentry.captureException(message);
}
